import { ReadyToPlayModalActionType } from '../../types/readyToPlayModalType'

export const closeReadyToPlayModal = () => {
    return {type: ReadyToPlayModalActionType.CLOSE_READY_TO_PLAY_MODAL}
}

export const openReadyToPlayModal = (id : number = 0, lobbyName : string = "") => {
    return {type: ReadyToPlayModalActionType.OPEN_READY_TO_PLAY_MODAL, payload: id, lobbyName : lobbyName}
}